import { beforeAfterItems } from "./beforeAfter.data";
import { Link } from "react-router-dom";

export default function BeforeAfterGallery() {
  const previewItems = beforeAfterItems.slice(0, 3);

  return (
    <section className="mx-auto w-full max-w-6xl px-6 py-20">
      <div className="mb-12 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#5481be] dark:text-[#89abe0]">
            რეალური პროექტები
          </p>
          <h2 className="mt-3 text-3xl font-bold text-[#0f2748] dark:text-[#e5efff] md:text-4xl">
            Before / After გალერეა
          </h2>
        </div>
        <p className="max-w-xl text-[#4f6587] dark:text-[#b5c9e8]">
          ჩვენი შესრულებული ობიექტები რეალური ფოტოებით, რომ განსხვავება მკაფიოდ
          ნახო.
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-3">
        {previewItems.map((item, index) => (
          <article
            key={item.id}
            className="premium-card animate-rise p-4"
            style={{ animationDelay: `${index * 120}ms` }}
          >
            <h3 className="mb-4 text-lg font-semibold text-[#0f2748] dark:text-[#e5efff]">{item.title}</h3>
            <div className="grid grid-cols-2 gap-3">
              <figure className="relative overflow-hidden rounded-xl">
                <Link to="/gallery">
                  <img
                    src={item.before}
                    alt={`${item.title} - Before`}
                    className="h-48 w-full object-cover transition duration-300 hover:scale-105"
                    loading="lazy"
                    onError={(event) => {
                      event.currentTarget.src = item.fallbackBefore || "/gallery/placeholder.svg";
                    }}
                  />
                </Link>
                <figcaption className="absolute bottom-2 left-2 rounded-full bg-[#153a6f]/90 px-3 py-1 text-xs font-semibold text-white">
                  Before
                </figcaption>
              </figure>

              <figure className="relative overflow-hidden rounded-xl">
                <Link to="/gallery">
                  <img
                    src={item.after}
                    alt={`${item.title} - After`}
                    className="h-48 w-full object-cover transition duration-300 hover:scale-105"
                    loading="lazy"
                    onError={(event) => {
                      event.currentTarget.src = item.fallbackAfter || "/gallery/placeholder.svg";
                    }}
                  />
                </Link>
                <figcaption className="absolute bottom-2 left-2 rounded-full bg-emerald-600/95 px-3 py-1 text-xs font-semibold text-white">
                  After
                </figcaption>
              </figure>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-8 text-center">
        <Link
          to="/gallery"
          className="inline-flex rounded-2xl bg-[#0f3d7a] px-7 py-3 text-sm font-semibold text-white transition hover:-translate-y-0.5 hover:bg-[#1452a3] dark:bg-[#284c7f] dark:hover:bg-[#3561a0]"
        >
          ყველა ნამუშევრის ნახვა
        </Link>
      </div>
    </section>
  );
}
